import { combineSlices } from '@reduxjs/toolkit';
import {
  manufacturersSlice,
  overallStatisticsSlice,
  productGroupsSlice,
} from './redux';

export const turnoverStatisticsReducer = combineSlices(
  overallStatisticsSlice,
  manufacturersSlice,
  productGroupsSlice,
);

